'use client';
import { createOpenAPIPage } from 'fumadocs-openapi/ui';

// Componente client que renderiza cada operação da API (parâmetros, schemas,
// exemplos e playground). Registrado em components/mdx.tsx.
export const OpenAPIPage = createOpenAPIPage();
